<template>
  <section>
    <div
      class="card d-flex flex-row p-0 rounded-4 transition-shadow
        box-shadow-pink-300 box-shadow-hover-pink-300 w-100 h-100"
      style="min-height:300px"
    >
      <div class="card text-center flex-md-row flex-column h-100 w-100">
        <div
          class="w-100 bg-white rounded-4 order-md-1 order-2"
          style="margin-right: -30px; z-index: 1"
        >
          <div
            class="h-100 card-body p-4
            d-flex flex-column justify-content-between"
          >
            <div class="h5 mb-2">
              {{ productName }}
            </div>
            <div class="mb-2 fw-bold">
              pour {{ formatPrice }} € / mois
            </div>
            <button
              type="button"
              class="btn btn-primary mx-auto px-5"
              @click="goToSubscription"
            >
              En savoir +
            </button>
          </div>
        </div>
        <div
          class="w-100 order-md-2 order-1"
          style="z-index: 0"
        >
          <div
            class="h-100 image-blog rounded-image container-image"
            :style="`background-image: url('${aws}/${product.productId}.jpg')`"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    product: {
      type: Object,
      default: () => ({ priceDetails: {} }),
    },
  },
  computed: {
    ...mapGetters({ products: 'rater/products' }),
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/dashboard/jpg/homepage/cross-sell`,
    formatPrice() {
      const price = this.product.priceDetails.monthlyPremium;
      return parseFloat(price || 0)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        .replace('.', ',');
    },
    productName() {
      return (this.products.find(({ id }) => id === this.product.productId)
        || { name: 'Protéger votre entreprise' })
        .name;
    },
  },
  methods: {
    goToSubscription() {
      // TODO changer cette fonction pour envoyer sur la bonne step de la vue Survey
      if (this.product.productId === 42) {
        window.location.assign(`${import.meta.env.VITE_WIDGET_URL}/survey/telework?products=${this.product.productId}`);
      } else if (this.product.productId === 16) {
        window.location.assign(`${import.meta.env.VITE_WIDGET_URL}/survey/local?products=${this.product.productId}`);
      } else {
        window.location.assign(`${import.meta.env.VITE_WIDGET_URL}/survey?products=${this.product.productId}`);
      }
    },
  },
};
</script>
<style scoped>
.rounded-image {
  border-radius: 0 15px 15px 0
}
.image-blog {
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
}
@media screen and (max-width: 567px) {
  .rounded-image {
    border-radius: 15px;
  }
  .image-blog {
    background-position: top;
  }
  .container-image {
    min-height: 200px;
    margin-bottom: -25px;
    border-radius: 15px;
  }
}
</style>
